<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">

    <div class="kaoji-title">{{row.danwei}}{{row.kaojitype}}</div>
<!--    <div class="kaoji-mine">我的身份：{{row.kaojitype}}{{row.user_type}}</div>-->

    <van-cell-group>
      <van-cell title="基本资料（电子授权证书）" is-link @click="toNext('QcxjDetailBase')"></van-cell>
      <van-cell title="成员信息" is-link @click="toNext('QcxjDetailCommunity')"></van-cell>
      <van-cell title="数据导出" is-link @click="toNext('CenterDownload')"></van-cell>
      <van-cell title="我的考级" is-link @click="toNext('ExameApplyListMine')"></van-cell>
      <van-cell title="新闻公告" is-link ></van-cell>
      <van-cell title="社群话题" is-link ></van-cell>
      <div style="height: 10px"></div>
    </van-cell-group>

    <div class="savebtn">
      <van-button color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 3rem" round
                  size="normal" @click="toKaojiNext">文化布置上传
      </van-button>
      <van-button color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                  style="width: 4rem" round @click="toContact"
                  size="normal">联系 石莎
      </van-button>
    </div>


    <van-dialog
            v-model="bookShow" 
            :show-confirm-button="false"
            :closeOnClickOverlay="true"
    >
    <img style="width:100%" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1751861173166-3.jpg" />
    </van-dialog>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>
  </div>
</template>
<style scoped>
.kaoji-title {
  padding: .3rem;
  font-size: 24px;
  text-align: center;
}

.kaoji-mine {
  padding: 0 .3rem .4rem;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  margin-right: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'QcxjDetail',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      bookShow:false,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      id: 0,
      row: {}
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = '七彩星级详情'
    that.id = this.$route.query.id;
    this.fetch();

  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/examecenter/centerdetail', {
        id : that.id,
      }, (res) => {
        that.row = res.data;
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    },
    unbind() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除单位认证吗?'
      }).then(() => {

        that.$api.post('/api/danwei/unbind', {}, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },

    toNext(name) {
      let that = this
      if(name == 'CenterDownload') { 
        appEvent({
          name: 'downloadFile',
          query: {
            name:'',
            url: window.root+'/api/exameCenter/centerDownload?center_id='+that.row.id
          }
        });
        return
      }


      // 
      rbLink({name:name, query: {id: this.row.id} })
    },

    toKaojiNext() {
      rbLink({
        name: 'QcxjStationApplyMine',
        query: {
          id: this.row.id,
          'showupload':1
        }
      });
    },

    toContact() {
      this.bookShow = true
      return ;
      rbLink({
        name:'H5',
        query:{
          url: 'https://developer.work.weixin.qq.com/document/path/92572'
        }
      })
    },

    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

  }
}
</script>



// WEBPACK FOOTER //
// QcxjDetail.vue?17df9ab0